import { checkinApi } from '@/services/api/httpClient';

const backofficeActions = {
  async updateBackofficeDone({ getters }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/backoffice`;
    try {
      // Necessário um data vazio para POST não ser bloqueado pelo WAF
      await checkinApi().post(url, {});
    } catch (err) {
      console.log(err);
    }
  },
};

export default backofficeActions;
